import React from "react";

export default class FeaturedStarV2SVG extends React.Component {
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 1200 1200">
        <defs>
          <style>{`.cls-1{fill:#fff;}.cls-2{fill:#f67171;}.cls-3{fill:#3c81f4;}.cls-4{fill:#da2626;}.cls-5{fill:#f7f8f9;}.cls-6{fill:#f8ca15;}.cls-7{fill:#4338c8;}.cls-8{fill:#333;}`}</style>
        </defs>
        <path
          class="cls-1"
          d="M1057.32,824.26,867.2,613.68l10.26-10.25a172.73,172.73,0,0,0,0-244.31L722.16,203.81a172.8,172.8,0,0,0-244.35,0l-44,44-13-59.3a35.49,35.49,0,0,0-69.34,0l-19.93,91-71.76,18.12a35.49,35.49,0,0,0,0,68.82l46.28,11.7a172.69,172.69,0,0,0,16.46,225.24l10.26,10.25L142.67,824.28a35.49,35.49,0,0,0,23.1,59.13l125,11.44,24.1,123.26A35.49,35.49,0,0,0,376.12,1035L580.94,808.23a168.82,168.82,0,0,0,38.13,0l204.85,226.86a35.5,35.5,0,0,0,61.18-17l24.07-123.27,125.06-11.44a35.49,35.49,0,0,0,23.09-59.15Z"
        />
        <polygon class="cls-2" points="818.26 612.43 1030.99 848.07 879.43 861.92 732.03 698.66 818.26 612.43" />
        <path
          class="cls-3"
          d="M892.24,471.48l-1.3.07a136.56,136.56,0,0,1-38.58,75.92l-34.1,34.1L732,667.8l-35,35a137.28,137.28,0,0,1-194.15,0l-35-35-86.2-86.23-34.1-34.1a136.56,136.56,0,0,1-38.58-75.92l-1.3-.07a137.11,137.11,0,0,1,39.88-87.28l16.57-16.54,21.94,100.43L410.81,355.6l93.11-23.52-83.2-21,82.19-82.19a137.31,137.31,0,0,1,194.15,0l155.3,155.3A137.11,137.11,0,0,1,892.24,471.48ZM667.93,549.2a96.09,96.09,0,1,0-135.89,0A96.08,96.08,0,0,0,667.93,549.2Z"
        />
        <polygon class="cls-4" points="732.03 698.66 879.43 861.92 872.61 896.89 716.66 714.03 732.03 698.66" />
        <path class="cls-2" d="M716.66,714l156,182.86L850.26,1011.3,632.34,770a136.51,136.51,0,0,0,64.72-36.36Z" />
        <ellipse class="cls-5" cx="599.98" cy="481.25" rx="96.08" ry="96.1" />
        <path class="cls-2" d="M502.91,733.63A136.56,136.56,0,0,0,567.66,770L349.74,1011.3,326.46,892.23h0L482.17,712.89Z" />
        <polygon
          class="cls-6"
          points="503.92 332.08 410.81 355.6 386.15 468.09 364.21 367.66 361.52 355.6 268.47 332.08 361.52 308.59 386.15 196.1 410.81 308.59 420.72 311.09 503.92 332.08"
        />
        <polygon class="cls-4" points="482.17 712.89 326.5 892.23 326.46 892.23 320.54 861.92 467.94 698.66 482.17 712.89" />
        <polygon class="cls-2" points="381.74 612.43 467.94 698.66 320.54 861.92 169 848.07 381.74 612.43" />
        <path
          class="cls-7"
          d="M852.36,547.47a136.56,136.56,0,0,0,38.58-75.92l1.3-.07a137,137,0,0,1-39.88,106.85l-34.1,34.1L732,698.66,716.66,714l-19.6,19.6A136.51,136.51,0,0,1,632.34,770a138.1,138.1,0,0,1-64.68,0,136.56,136.56,0,0,1-64.75-36.36L482.2,712.89h0v0l-14.23-14.2-86.2-86.23-34.1-34.1a137,137,0,0,1-39.88-106.85l1.3.07a136.56,136.56,0,0,0,38.58,75.92l34.1,34.1,86.2,86.23,35,35a137.27,137.27,0,0,0,194.15,0l35-35,86.23-86.23Z"
        />
        <path
          class="cls-8"
          d="M818.26,617.06a4.63,4.63,0,0,1-3.28-7.9l34.11-34.1a132.61,132.61,0,0,0,0-187.59L693.79,232.18a132.67,132.67,0,0,0-187.61,0L424,314.37a4.63,4.63,0,0,1-6.54-6.55l82.18-82.19a141.93,141.93,0,0,1,200.7,0l155.31,155.3a141.87,141.87,0,0,1,0,200.67l-34.11,34.11A4.62,4.62,0,0,1,818.26,617.06Z"
        />
        <path
          class="cls-8"
          d="M600,778.44a142.69,142.69,0,0,1-33.44-4,4.63,4.63,0,0,1,2.17-9,133.73,133.73,0,0,0,62.52,0,4.63,4.63,0,0,1,2.17,9A142.46,142.46,0,0,1,600,778.44Z"
        />
        <path
          class="cls-8"
          d="M502.91,738.26a4.59,4.59,0,0,1-3.28-1.36l-20.56-20.59a4.62,4.62,0,0,1,3.1-8h0a4.62,4.62,0,0,1,3.27,1.36l20.71,20.74a4.63,4.63,0,0,1-3.27,7.9Z"
        />
        <path
          class="cls-8"
          d="M482.17,717.49a4.6,4.6,0,0,1-3.27-1.35l-14.23-14.2a4.63,4.63,0,1,1,6.54-6.55l14.23,14.19a4.64,4.64,0,0,1,0,6.55A4.59,4.59,0,0,1,482.17,717.49Z"
        />
        <path
          class="cls-8"
          d="M381.74,617.06a4.62,4.62,0,0,1-3.27-1.35L344.36,581.6a141.87,141.87,0,0,1,0-200.67l16.58-16.54a4.63,4.63,0,1,1,6.54,6.55l-16.57,16.54a132.6,132.6,0,0,0,0,187.58l34.1,34.1a4.63,4.63,0,0,1-3.27,7.9Z"
        />
        <path
          class="cls-8"
          d="M600,582a100.72,100.72,0,1,1,71.2-29.5h0A100,100,0,0,1,600,582Zm0-192.18a91.46,91.46,0,1,0,64.65,156.13h0A91.46,91.46,0,0,0,600,389.79Z"
        />
        <path
          class="cls-8"
          d="M320.55,866.55h-.43L168.58,852.68a4.63,4.63,0,0,1-3-7.72L378.3,609.33a4.62,4.62,0,0,1,3.32-1.52,4.26,4.26,0,0,1,3.39,1.35l86.2,86.23a4.63,4.63,0,0,1-6.55,6.55l-82.75-82.79L178.64,844.3l142.32,13a4.63,4.63,0,0,1-.41,9.24Z"
        />
        <path
          class="cls-8"
          d="M349.74,1015.93a4.75,4.75,0,0,1-1.24-.17,4.64,4.64,0,0,1-3.31-3.57L316,862.81a4.64,4.64,0,0,1,1.1-4L464.5,695.56a4.62,4.62,0,0,1,3.32-1.52,4.44,4.44,0,0,1,3.39,1.35l35,35a132.23,132.23,0,0,0,62.56,35.12,4.63,4.63,0,0,1,2.35,7.61L353.17,1014.4A4.61,4.61,0,0,1,349.74,1015.93ZM325.53,863.31l27,138L559.16,772.49a141.62,141.62,0,0,1-59.53-35.59l-31.52-31.52Z"
        />
        <path
          class="cls-8"
          d="M879.42,866.55a4.63,4.63,0,0,1-.41-9.24l142.35-13L818.09,619.15,735.3,701.94a4.63,4.63,0,0,1-6.54-6.55L815,609.16a4.38,4.38,0,0,1,3.39-1.35,4.62,4.62,0,0,1,3.32,1.52L1034.43,845a4.63,4.63,0,0,1-3,7.72L879.85,866.54Z"
        />
        <path
          class="cls-8"
          d="M850.26,1015.93a4.61,4.61,0,0,1-3.43-1.53L628.91,773.09a4.63,4.63,0,0,1,2.35-7.61,132.24,132.24,0,0,0,62.53-35.12l35-35a4.43,4.43,0,0,1,3.39-1.35,4.6,4.6,0,0,1,3.31,1.52l147.4,163.26a4.62,4.62,0,0,1,1.11,4l-29.16,149.38a4.64,4.64,0,0,1-3.31,3.57A4.81,4.81,0,0,1,850.26,1015.93ZM640.84,772.48l206.65,228.85,27-138L731.86,705.38,700.33,736.9A141.48,141.48,0,0,1,640.84,772.48Z"
        />
        <path
          class="cls-8"
          d="M386.15,472.72h0a4.63,4.63,0,0,1-4.52-3.64l-24-109.7-90.29-22.81a4.63,4.63,0,0,1,0-9l90.28-22.79,24-109.69a4.63,4.63,0,0,1,9,0l24.05,109.7,90.34,22.79a4.63,4.63,0,0,1,0,9l-90.34,22.81-24.05,109.7A4.61,4.61,0,0,1,386.15,472.72ZM287.38,332.08l75.28,19a4.61,4.61,0,0,1,3.38,3.48l2.69,12.07,17.43,79.78,20.13-91.84a4.62,4.62,0,0,1,3.39-3.49l75.33-19-65.42-16.5h0l-9.91-2.5a4.63,4.63,0,0,1-3.39-3.5l-20.13-91.85-20.11,91.85a4.65,4.65,0,0,1-3.39,3.5Z"
        />
      </svg>
    );
  }
}
